import React from 'react';

const ToneSelector = ({ selectedTone, onToneSelect }) => {
    const toneOptions = [
        {
            id: 'neutral',
            label: 'Neutral',
            icon: 'fas fa-briefcase',
            description: 'Clear, direct, and business-appropriate'
        },
        {
            id: 'professional',
            label: 'Professional',
            icon: 'fas fa-briefcase',
            description: 'Clear, direct, and business-appropriate'
        },
        {
            id: 'formal',
            label: 'Formal',
            icon: 'fas fa-gavel',
            description: 'Structured, respectful, and traditional'
        },
        {
            id: 'friendly',
            label: 'Friendly',
            icon: 'fas fa-handshake',
            description: 'Warm, approachable, yet professional'
        },
        {
            id: 'conversational',
            label: 'Conversational',
            icon: 'fas fa-compress-alt',
            description: 'Natural and human-like'
        },
        {
            id: 'concise',
            label: 'Concise',
            icon: 'fas fa-compress-alt',
            description: 'Brief, clear, and to the point'
        },
        {
            id: 'empathetic',
            label: 'Empathetic',
            icon: 'fas fa-heart',
            description: 'Understanding, supportive, and considerate'
        }
    ];

    const handleToneSelect = (toneId) => {
        onToneSelect(toneId);
    };

    return (
        <div className="flex flex-col gap-4">
            <label className="label">
                <i className="fas fa-palette label-icon"></i>
                Select Tone
            </label>

            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3">
                {toneOptions.map((option) => (
                    <div
                        key={option.id}
                        onClick={() => handleToneSelect(option.id)}
                        className={`tone-option ${selectedTone === option.id ? 'active' : ''}`}
                        title={option.description}
                        role="button"
                        tabIndex={0}
                        onKeyDown={(e) => {
                            if (e.key === 'Enter' || e.key === ' ') {
                                e.preventDefault();
                                handleToneSelect(option.id);
                            }
                        }}
                    >
                        <div className="flex items-start gap-3 w-full">
                            <i className={`${option.icon} text-xl mt-0.5 flex-shrink-0 tone-icon`}></i>
                            <div className="flex flex-col text-left min-w-0 flex-1">
                                <span className="font-semibold text-sm leading-tight text-gray-900 dark:text-gray-100">
                                    {option.label}
                                </span>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default ToneSelector;
